<template>
  <el-main class="container">
    <Nav>
      <div
        slot="left"
        class="left">
        <el-input
          clearable
          class="input-text"
          v-model="body.word"
          maxlength="99"
          placeholder="请输入订单编号/拜访人姓名搜索"/>
          <el-button type="primary" @click="event().search()">搜索</el-button>
        <div class="select-date">
          <span>选择日期</span>
          <el-date-picker
            v-model="value1"
            @change="event().selectDate($event)"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div class="right" slot="right">
        <el-button
          ype="primary"
          class="excel"
          v-if="false"
          type="primary">
          导出Excel</el-button>
      </div>
    </Nav>
    <div class="company-name">
      <span>{{companyName}}</span>
    </div>
    <table-pagination
      ref="table"
      class="table"
      :config="config"
      :datasource="datasource"
      :idRow="false"
      @change-page="handlerPageChange"
      @change-page-num="handlerPageNum">
      <el-table-column
        slot="action"
        fixed="right"
        label="操作"
        width="385"
        align="center">
        <template slot-scope="scope">
          <div>
            <el-link
              :underline="false"
              type='primary'
              class="details"
              @click="handlerRouter('get', scope)">
              查看详情</el-link>
          </div>
        </template>
      </el-table-column>
    </table-pagination>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
import { ExchangeDate } from '@/jslib/utils'
import TablePagination from '@/components/table-pagination'
import { getVisitorList } from '@/api/company'
export default {
  name: 'VisitManagement',
  data() {
    return {
      value1: '',
      body: {
        uuid: '',
        pageIndex: 1,
        pageSize: 10,
        dateMin: '',
        dateMax: '',
        word: '',
        industryUuid: ''
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'orderNum',
            label: '订单编号'
          },
          {
            prop: 'type',
            label: '拜访类型',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '临时访客'
              },
              {
                value: 1,
                label: '企业访客'
              }
            ]
          },
          {
            prop: 'name',
            label: '拜访人',
            type: 'show',
            rule: [
              {
                value: '-',
                label: ''
              }
            ]
          },
          {
            prop: 'enterpriseName',
            label: '拜访企业'
          },
          {
            prop: 'reservationDate',
            label: '拜访时间'
          },
          {
            prop: 'status',
            label: '状态',
            type: 'status',
            rule: [
              {
                value: 0,
                label: '未完成'
              },
              {
                value: 1,
                label: '已完成'
              },
              {
                value: 2,
                label: '已取消'
              },
              {
                value: 3,
                label: '待审核'
              },
              {
                value: 4,
                label: '已拒绝'
              }
            ]
          }
        ]
      },
      datasource: {
        total: 0,
        data: []
      },
      companyName: ''
    }
  },
  created() {
    let row = JSON.parse(this.$route.query.info)
    console.log(row, '123123');
    if(this.$route.query.type === 'company'){
      this.body.uuid = row.uuid
    } else if (this.$route.query.type === 'industry')(
      this.body.industryUuid = row.uuid
    )
    this.network().getVisitorList()
  },
  methods: {
    event() {
      return {
        selectDate: (e) => {
          if (e == null) {
            this.body.dateMin = ''
            this.body.dateMax = ''
          } else {
            this.body.dateMin = ExchangeDate(this.value1[0])
            this.body.dateMax = ExchangeDate(this.value1[1])
          }
          this.network().getVisitorList()
        },
        search: () => {
          this.network().getVisitorList()
        }
      }
    },
    network() {
      return {
        getVisitorList: async() => {
          const { data } = await getVisitorList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
          this.companyName = data.list[0].enterpriseName
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getVisitorList()
    },
    handlerPageNum(data){
      this.body.pageIndex = 1
      this.body.pageSize = data.pageNum
      this.network().getVisitorList()
    },
    handlerRouter(type, scope) {
      let id = this.body.uuid ? this.body.uuid : this.body.industryUuid
      this.$router.push({
        path: `/company-management/company-visit/get/${id}/visit-details/${type}${
          scope ? `/${scope.row.uuid}` : ''
        }`,
        query: { uuid: scope.row.uuid }
      })
    },
  },
  // beforeRouteEnter(to, form, next){
  //   next(vm=>{
  //     if(form.name !== 'VisitDetails') {
  //       vm.$store.dispatch('global/deleteRoute', 'VisitManagement')
  //     }
  //   })
  //   next()
  // },
  beforeRouteLeave(to, form, next){
    if(to.name !== 'VisitDetails'){
      this.$store.dispatch('global/deleteRoute', 'VisitManagement')
    }
    next()
  },
  components: {
    Nav,
    TablePagination
  },
}
</script>

<style scoped lang="scss">
.container{
  Nav{
    margin-bottom: 15px;
  }
  .select-date{
    display: flex;
    align-items: center;
    margin-left: 90px;
    span{
      margin-right: 15px;
    }
  }

  .company-name{
    font-weight: bold;
  }
  .table{
    margin-top: 30px;
  }
}
/deep/ .table{
  /deep/ .el-table__body .el-table__row{
    height: 150px;
  }
}
</style>
